module.exports = __webpack_public_path__ + "assets/pdf/BN04-cn-communicating-uncertainity.5274f522.pdf";